import React from 'react';
import {Link} from 'react-router-dom';
import _SendNeedofferForm from './_SendNeedofferForm.scss';

class SendNeedofferForm extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <div className="needoffer-box">
        <div className="needoffer-logo">
          <b>Chào hàng/Yc báo giá</b>
          <p>Nhận báo giá yêu cầu của bạn. Nói với nhà cung cấp những gì bạn cần.</p>
        </div>

        <div className="needoffer-box-body">
          <form>
            <div className="form-group has-feedback fg-custom">
              <input type="text" className="form-control" placeholder="Nhập tên sản phẩm..."/>
              <span className="fa fa-user-o form-control-feedback"></span>
            </div>
            <div className="content-justify">
              <div className="form-group has-feedback fg-custom email-input">
                <input type="email" className="form-control" placeholder="Email của bạn..."/>
                <span className="fa fa-at form-control-feedback"></span>
              </div>
              <div className="form-group has-feedback fg-custom phone-input">
                <input type="text" className="form-control" placeholder="Số điện thoại..."/>
                <span className="glyphicon glyphicon-user form-control-feedback"></span>
              </div>
            </div>
            <textarea rows="10" className="needoffer-content"></textarea>
            <div className="content-justify needoffer-footer">
              <div className="checkbox term">
                <label>
                  <input type="checkbox"/>
                  Tôi đồng ý với
                  <Link to="/cms/djieu-khoan-and-djieu-kien-giao-dich">điều kiện sử dụng và chính sách của Vitrade</Link>
                </label>
              </div>
              <button type="submit" className="update-btn">Chào hàng/Yc báo giá</button>
            </div>
          </form>

        </div>

      </div>
    );
  }
}

export default SendNeedofferForm;



// WEBPACK FOOTER //
// ./components/send-needoffer/SendNeedofferForm.jsx